import React, {FC} from 'react';

import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {AdditionalHelpSection} from './additionalHelpSection';
import {RecommendedHelpSection} from './recommendedHelpSection';

/*
 * Props.
 */

interface HelpTopicsProps {
  panelId: AppPanelId;
}

/*
 * Component.
 */

export const HelpTopics: FC<HelpTopicsProps> = (props) => {
  const {panelId} = props;
  return (
    <>
      <RecommendedHelpSection />
      <AdditionalHelpSection panelId={panelId} />
    </>
  );
};
